import { render } from "./DismissModal.vue?vue&type=template&id=7b94cecc"
import script from "./DismissModal.vue?vue&type=script&lang=js"
export * from "./DismissModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__